export default {"src":"/_next/static/media/save.1a032588.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};